import { type RouteRecordRaw } from 'vue-router'
export const staffRouter: RouteRecordRaw[] = [
  {
    async beforeEnter() {
      // Enable MSW mocking for staff routes in development mode
      if (
        import.meta.env.MODE === 'development' &&
        import.meta.env.VITE_ENABLE_MOCKS === 'true'
      ) {
        const { startMockWorker, isMockWorkerStarted } = await import(
          '@/mocks/browser'
        )
        if (!isMockWorkerStarted()) {
          await startMockWorker()
        }
      }
    },

    children: [
      {
        component: async () => import('../views/BrandStaffMembersView.vue'),
        meta: { scopes: ['users:read'], title: 'staff-members' },
        name: 'brand.staff.members',
        path: 'members',
      },
      {
        component: async () => import('../views/BrandStaffJobsView.vue'),
        meta: { scopes: ['jobs:read'], title: 'staff-jobs' },
        name: 'brand.staff.jobs',
        path: 'jobs',
      },
      {
        component: async () => import('../views/StaffTimesheetsView.vue'),
        meta: {
          title: 'staff-timesheets',
        },
        name: 'brand.staff.timesheets',
        path: 'timesheets',
      },
    ],
    path: 'staff',
  },
]
